import { FaCube } from 'react-icons/fa'

export const Data = [
    {
        icon: <FaCube/>,
        title: 'Answer 5 English questions in 48 hours to collect 50points',
        timeDuration: '2d : 00h',
        cta: 'Start'
    },
    {
        icon: <FaCube/>,
        title: 'Answer 25 questions from any subject in 48hrs to collect 400 points',
        timeDuration: '2d : 00h',
        cta: 'Start'
    },
    {
        icon: <FaCube/>,
        title: 'Complete profile to earn 500 points',
        timeDuration: '2d : 00h',
        cta: 'Start'
    },
    {
        icon: <FaCube/>,
        title: 'Refere a friend and Earn 20points',
        timeDuration: '2d : 00h',
        cta: 'Start'
    },
] 